var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"e3-svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":Number(_vm.size),"height":Number(_vm.size),"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M21 7L9 19 3.5 13.5 5.62 11.38 9 14.76 18.88 4.88 21 7z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }